import { render } from "./WasteType.vue?vue&type=template&id=442c7e88&scoped=true"
import script from "./WasteType.vue?vue&type=script&lang=js"
export * from "./WasteType.vue?vue&type=script&lang=js"

import "./WasteType.vue?vue&type=style&index=0&id=442c7e88&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442c7e88"]])

export default __exports__